/**
 * The persistent credit in the top-right corner.
 *
 * Fixed rather than sticky so it survives on both the catalogue (which scrolls)
 * and the planner (which does not). Sits below the item tooltip's z-index so a
 * hover card is never obscured by it.
 *
 * The "unofficial" line is not decoration: Bungie's API terms expect fan tools
 * to be clearly distinguishable from official ones.
 */
/** `children` is where the account controls go, so there is one fixed bar in the
 *  corner rather than two competing for the same space. */
export function SiteCredit({ children }: { children?: React.ReactNode }) {
  return (
    <div className="fixed top-0 right-0 z-40 flex items-center gap-2 border-b border-l border-line-dim bg-void/80 px-3 py-1.5 text-[0.65rem] backdrop-blur-sm">
      {children}
      {children && <span aria-hidden className="h-3 w-px bg-line-dim" />}
      <a
        href="https://ehko.dev"
        target="_blank"
        rel="noreferrer noopener"
        className="label-caps text-ink-2 transition-colors hover:text-ink"
      >
        ehko.dev
      </a>
    </div>
  );
}
